import Textarea from 'react-textarea-autosize';
import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const TextareaStyled = styled(Textarea)`
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 3px 2px;
  border: none;
  border-bottom: 1px solid ${COLORS.line};
  background-color: transparent;
  outline: none;
  font-size: 16px;
  color: #fff;
  resize: none;

  &:focus {
    border-color: rgba(255, 255, 255, 0.6);
  }
`;

export default TextareaStyled;
